import { Component, EventEmitter, Input, Output } from '@angular/core';
import { KnowledgeStatus } from '../../interfaces/knowledge-status.interface';

@Component({
  selector: 'app-knowledge-check',
  standalone: false,
  templateUrl: './knowledge-check.component.html',
  styleUrls: ['./knowledge-check.component.scss']
})
export class KnowledgeCheckComponent {
  @Input() status: KnowledgeStatus | null = null;
  @Input() loading = false;
  @Input() error = false;
  @Input() loadingMessage = '';
  @Input() technicalDocsLabel = '';
  @Input() dbScriptsLabel = '';
  @Input() errorMessage = '';
  @Output() navigate = new EventEmitter<void>();
}
